module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBbaIe17AAAAP0lEQVQ4y2P4jwQ+MAww7wADDNgPDp490F2DhPf/AP8fhsHAgzIGCw/VZQPIY2D+P3h4A51a0XiDJE8PnrIOAN8aq3FJjEVmAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE4LTA4LTE2VDE2OjU4OjM5KzA5OjAwJ9kZSgAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxMy0xMC0wOFQwNjowODoyMiswOTowMD+oKM0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h10/tag36_10_00000_100x100.png
// module id = UUhc
// module chunks = 0